<ng-container *ngIf="isEdit; else createShell">
    <ng-container *ngTemplateOutlet="wizard"></ng-container>
</ng-container>

<ng-template #createShell>
    <ion-content id="create-offer-content">
        <div class="container content-wrapper">
            <ng-container *ngTemplateOutlet="wizard"></ng-container>
        </div>
        <app-footer></app-footer>
    </ion-content>
</ng-template>

<ng-template #wizard>
    <div class="d-flex justify-content-center flex-column align-items-center pb-4 create-offer-wizard-header">
        <h1>{{ (isEdit ? 'Update offer' : 'Publish your offer') | translate }}</h1>
        <div class="card p-3 mb-3 w-100" style="max-width: 720px" *ngIf="isEdit && editPlatformLabel">
            <div class="d-flex flex-column flex-md-row justify-content-between gap-2">
                <div>
                    <div class="text-muted small text-uppercase">{{ 'Platform' | translate }}</div>
                    <div class="fw-semibold">{{ editPlatformLabel | translate }}</div>
                </div>
                <div>
                    <div class="text-muted small text-uppercase">{{ 'Category' | translate }}</div>
                    <div class="fw-semibold">{{ editCategoryFullName }}</div>
                </div>
            </div>
        </div>
        <div class="create-offer-tabs w-100">
            <div class="horizontal-menu horizontal-menu-inline">
                <ng-container *ngFor="let t of tabs">
                    <div
                        class="horizontal-menu-item"
                        [ngClass]="{active: tab === t.slug}"
                        (click)="selectTab(t.slug)"
                        [class.disabled]="!canSelectTab(t.slug)"
                        *ngIf="!t.disabled"
                    >
                        <span [ngClass]="t.color ? 'text-' + t.color : ''">
                            {{ t.text|translate }} <i [class]="'bi bi-' + t.icon" *ngIf="t.icon"></i>
                        </span>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-center">
        <div class="inner-container" *ngIf="authorized !== null else loading">
            <app-pick-platform
                *ngIf="tab === 'platform'"
                (nextStep)="nextStep($event)"
                [authorized]="authorized"
                [todoList]="todoList"
                [data]="data"
                [readonly]="isEdit"
                [isEdit]="isEdit"
            ></app-pick-platform>
            <app-pick-category
                *ngIf="tab === 'category'"
                (nextStep)="nextStep($event)"
                [data]="data"
                [readonly]="isEdit"
                [isEdit]="isEdit"
            ></app-pick-category>
            <app-pick-filters *ngIf="tab === 'filters'" (nextStep)="nextStep($event)" [data]="data" [isEdit]="isEdit"></app-pick-filters>
            <app-pick-prices
                *ngIf="tab === 'price'"
                (nextStep)="nextStep($event)"
                [data]="data"
                [editOfferId]="isEdit ? (offerToEdit?.id ?? null) : null"
                [isEdit]="isEdit"
            ></app-pick-prices>
            <app-pick-addresses
                *ngIf="tab === 'location'"
                (nextStep)="nextStep($event)"
                [data]="data"
                [useLocationModal]="shouldUseLocationModal()"
                [initialAddress]="isEdit ? (offerToEdit?.address ?? null) : null"
                [isEdit]="isEdit"
            ></app-pick-addresses>
            <app-pick-medias *ngIf="tab === 'photos'" (nextStep)="nextStep($event)" [data]="data" [isEdit]="isEdit"></app-pick-medias>
            <div *ngIf="tab === 'boost'">
                <div class="py-5 text-center">
                    {{ 'Coming soon'|translate }}
                    <div class="form-group pb-5">
                        <button
                            *ngIf="!isEdit"
                            type="button"
                            class="btn btn-lg btn-primary d-inline-flex align-items-center"
                            (click)="publishOffer()"
                        >
                            {{ "Publish offer" | translate }} <span class="bi ps-2 bi-arrow-right"></span>
                        </button>
                        <button
                            *ngIf="isEdit"
                            type="button"
                            class="btn btn-lg btn-primary d-inline-flex align-items-center"
                            [disabled]="isSavingOffer || resubmitting"
                            (click)="resubmit.emit()"
                        >
                            {{ (editValidationStatus === 'rejected' ? 'offer_resubmit_button' : 'Save offer') | translate }}
                            <span class="bi ps-2 bi-arrow-right"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #loading>
            <div class="text-center py-5">
                <ion-spinner name="crescent"></ion-spinner>
            </div>
        </ng-template>
    </div>
</ng-template>
